import { Component, inject, signal } from '@angular/core';
import { LANGUAGES } from 'src/app/app.constants';
import { LanguageService } from 'src/app/services/language.service';
import { UpperCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-language-selector',
    imports: [
        UpperCasePipe,
        FormsModule
    ],
    templateUrl: './language-selector.component.html',
    styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  private languageService = inject(LanguageService);

  readonly currentLanguage = this.languageService.currentLanguage;

  public data = signal(LANGUAGES);

  changeLanguage(event: any) {
   this.languageService.changeLanguage(event.target.value);
  }
}
